import React from "react";
import classNames from "classnames";
/* Styles */
import "./popup.css";

const PopupGeneric = ({ isOpen, children, customClassName }) => {

  if (!isOpen) return null;

  return (
    <div className={classNames("popup-overlay-generic", {"open":isOpen},customClassName)}>
        <div className="w-full h-full overflow-y-auto p-4 sm-max:p-0 flex justify-center items-center">
          {children}
        </div>
    </div>
  );
};

export default PopupGeneric;
